module.exports = __webpack_public_path__ + "media/signup-react/claim-samples-8c43dfb6.png";